import { TicketingPrizeOutput } from "../types";

import { MAX_LARGE_DESKTOP_PRIZES } from "./constants";

export interface DesktopPrizeLayout {
  largePrizes: TicketingPrizeOutput[];
  compactPrizeColumns: TicketingPrizeOutput[][];
}

export const getDesktopPrizeLayout = (prizes: TicketingPrizeOutput[]): DesktopPrizeLayout => {
  if (prizes.length <= MAX_LARGE_DESKTOP_PRIZES) {
    return { largePrizes: prizes, compactPrizeColumns: [] };
  }

  const [firstPrize, ...otherPrizes] = prizes;
  const compactPrizeColumns: TicketingPrizeOutput[][] = [];
  for (let index = 0; index < otherPrizes.length; index += 2) {
    compactPrizeColumns.push(otherPrizes.slice(index, index + 2));
  }
  return { largePrizes: [firstPrize], compactPrizeColumns };
};
